import { ImageRun } from 'docx';
import type { NodeEntry } from 'slate';

import type { DocumentContext } from './internal';
import { Queries } from '../../../slate-api';
import type { DrawingElement } from '../../../slate-api';
import type { ImageFormat } from '../../../types';

type DocxImageFormat = 'bmp' | 'gif' | 'jpg' | 'png';

const DOCX_IMAGE_FORMATS: Partial<Record<ImageFormat, DocxImageFormat>> = {
  bmp: 'bmp',
  gif: 'gif',
  jpeg: 'jpg',
  png: 'png',
};

export function createDocxDrawing(
  drawingEntry: NodeEntry<DrawingElement>,
  options: { context: DocumentContext }
): ImageRun {
  const [drawing] = drawingEntry;
  const dimensions = Queries.getDrawingDimensions(drawing);
  const transforms = Queries.getDrawingVisualProperties(drawing);
  const nonVisualProps = Queries.getDrawingNonVisualProperties(drawing);

  const imageAsset = options.context.imageMap.get(drawing.drawingImgId);
  if (!imageAsset)
    throw new Error(`createDocxDrawing: Drawing with id ${drawing.drawingImgId} not found in Map.`);

  const type = imageAsset.format ? DOCX_IMAGE_FORMATS[imageAsset.format] : null;
  if (!type) {
    throw new Error(
      `createDocxDrawing: Drawing with id ${drawing.drawingImgId} has an unsupported image format.`
    );
  }

  return new ImageRun({
    altText: {
      description: nonVisualProps.descr ?? '',
      name: nonVisualProps.name ?? '',
      title: nonVisualProps.title ?? '',
    },
    data: imageAsset.base64,
    transformation: {
      flip: {
        horizontal: transforms.flippedHorizontal,
        vertical: transforms.flippedVertical,
      },
      height: dimensions.imgHeightPx,
      rotation: transforms.rotation,
      width: dimensions.imgWidthPx,
    },
    type,
  });
}
